export const iconFontAwesomeMapsWheelchairMove = (
	<i className="fa-solid fa-wheelchair-move"></i>
);
